import AccountsTable from './AccountsTable'

export default AccountsTable
